
const addMissingStats = (data, teams, drivers) => {
  const newData = [...data]
  teams.forEach((team) => {
    drivers.forEach((driver) => {
      const statExists = data.find((item) => {
        return item.teamId === team.uuid && item.driverId === driver.id
      })
      if (!statExists) newData.push({driver, team, averageScore: 0, driverId: driver.id, teamId: team.uuid})
    })
  })
  return newData
}

export default addMissingStats
